/**
 * Shared wiring for the `@dl/ui` color-picker primitive (#219).
 *
 * The curated swatch row + the localised `ColorPickerMessages` are identical
 * across every consumer (the Settings `accent_color` editor, `color`-kind
 * fact editing, the component gallery), so they live here once — DRY — rather
 * than being rebuilt at each call site. The swatches are the §10.2.1
 * campaign-accent palette (`CAMPAIGN_ACCENT_SWATCHES`), with localised names.
 */

import { CAMPAIGN_ACCENT_SWATCHES, type ColorPickerMessages, type ColorSwatch } from '@dl/ui';

import { t } from './i18n.js';

/** The §10.2.1 curated palette as `{ value, label }` swatches with i18n names. */
export function campaignAccentSwatches(): ColorSwatch[] {
  return CAMPAIGN_ACCENT_SWATCHES.map((s) => ({
    value: s.hex,
    label: t(`color.swatch.${s.accent}`),
  }));
}

/** The localised copy for the color picker, shared across consumers. */
export function colorPickerMessages(): ColorPickerMessages {
  return {
    group: t('color.group'),
    swatches: t('color.swatches'),
    custom: t('color.custom'),
    hex: t('color.hex'),
    hexPlaceholder: t('color.hex_placeholder'),
  };
}
